import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import NameDropdown from './NameDropdown';
import { withTranslation } from 'react-i18next';
import CustomersActions from '../../redux/CustomersRedux';
import AuthActions from '../../redux/AuthRedux';
import DistributorsActions from '../../redux/DistributorsRedux';
import { Colors, Metrics } from '../../themes';
import SvgIcon from '../../icons/SvgIcon';

const StyledContainer = styled.div`
  padding: 20px 15px 8px;
  @media (max-width: ${Metrics.breakpoints.lg - 1}px) {
    padding-top: 8px;
  }
`;
const TopIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 30px;
  margin-right: 8px;
`;

const NameContainer = styled.div`
  margin-top: 20px;
`;
const ResponsiveSvgIcon = styled(SvgIcon)`
  @media (max-width: ${Metrics.breakpoints.lg - 1}px) {
    display: none;
  }
`;

class SidebarHeader extends Component {
  state = {
    isreadyToClose: false,
    hasSelected: false,
  };

  componentDidUpdate(prevProps) {
    //if customers have changed, select one automatically
    if (this.props.customers !== prevProps.customers) {
      // if there are 0 or 1 customer, close the drawer.
      if (this.state.isreadyToClose && this.props.customers.length < 2) {
        this.props.handleDrawerToggle();
        this.setState({ isreadyToClose: false });
      }
      // if only one customer, select it automatically
      if (this.props.customers.length === 1) {
        this.props.selectCustomer(this.props.customers[0].customerId, this.props.customers[0].customerIdSub);
      }
      const defaultCustomer = this.props.customers.find(
        ({ customerIdSub }) => customerIdSub === this.props.defaultCustomerIdSub
      );
      // if defaultCustomer (from token) exists among customers, select it
      if (defaultCustomer) {
        this.props.selectCustomer(defaultCustomer.customerId, this.props.defaultCustomerIdSub);
      }

      // if no customer, set customerId to null
      if (this.props.customers !== prevProps.customers && this.props.customers.length === 0) {
        this.props.selectCustomer(null, null);
      }
    }
  }

  render() {
    const { t, isSystemAdmin, isDistributorAdmin } = this.props;
    return (
      <StyledContainer className="SidebarHeader__StyledContainer">
        <TopIconsContainer>
          <ResponsiveSvgIcon className="Digiovi__Icon" icon="Digiovi" width={111.58} color={Colors.white} />
        </TopIconsContainer>
        <NameContainer className="SidebarHeader__NameContainer">
          {(isSystemAdmin || isDistributorAdmin) && (
            <NameDropdown
              data={isSystemAdmin ? this.props.distributors : [this.props.distributorInfo]}
              type={t('distributor')}
              disabled={!isSystemAdmin}
              isDistributor={true}
              defaultCompanyId={this.props.distributorIdSub}
              onSelect={(sub) => {
                const selectedDistributor = this.props.distributors.find(
                  (distributor) => distributor.distributorIdSub === sub
                );
                const distributorId = selectedDistributor.distributorId;
                this.props.selectDistributor(distributorId, sub);
                this.props.getDistributorInfo(distributorId);
                this.props.getCustomersByDistributor(distributorId);
                !this.props.biggerThanLarge && this.setState({ isreadyToClose: true }); //ready to close drawer if next distributor has 0 or 1 customer
              }}
            />
          )}
          <NameDropdown
            data={this.props.customers.length > 0 ? this.props.customers : []}
            type={t('customer.customer')}
            disabled={!(isSystemAdmin || isDistributorAdmin) || this.props.customers.length === 0}
            isDistributor={false}
            defaultCompanyId={this.props.customerIdSub}
            noEntry={`-${t('customer.noCustomer')}-`}
            onSelect={(sub) => {
              const selectedCustomer = this.props.customers.find((customer) => customer.customerIdSub === sub);
              const customerId = selectedCustomer.customerId;
              this.props.selectCustomer(customerId, sub);
              !this.props.biggerThanLarge && this.props.handleDrawerToggle();
            }}
          />
        </NameContainer>
      </StyledContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    distributorId: state.auth.distributorId,
    distributorIdSub: state.auth.distributorIdSub,
    customerId: state.auth.customerId,
    customerIdSub: state.auth.customerIdSub,
    defaultCustomerIdSub: state.auth.defaultCustomerIdSub,
    distributorInfo: state.distributors.distributorInfo,
    distributors: state.distributors.distributors,
    customers: state.customers.customers,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getDistributorInfo: (distributorId) => dispatch(DistributorsActions.getDistributorInfoRequest(distributorId)),
  resetDistributorInfo: () => dispatch(DistributorsActions.resetDistributorInfo()),
  getCustomersByDistributor: (distributorId) =>
    dispatch(CustomersActions.getCustomersByDistributorRequest(distributorId)),
  selectDistributor: (id, sub) => dispatch(AuthActions.selectDistributor(id, sub)),
  selectCustomer: (id, sub) => dispatch(AuthActions.selectCustomer(id, sub)),
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SidebarHeader);
